import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=86e5c456&"
import script from "./Pix.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pix.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports